<div class="connection-status" *ngIf="!loading">
	<div class="status-indicator" [class.connected]="connectionStatus?.connected" [class.disconnected]="!connectionStatus?.connected">
		<mat-icon *ngIf="connectionStatus?.connected">check_circle</mat-icon>
		<mat-icon *ngIf="!connectionStatus?.connected">cancel</mat-icon>
		<span *ngIf="connectionStatus?.connected">{{ 'SETTINGS.MESSAGING.STATUS_CONNECTED' | translate | capitalize }}</span>
		<span *ngIf="!connectionStatus?.connected">{{ 'SETTINGS.MESSAGING.STATUS_DISCONNECTED' | translate | capitalize }}</span>
	</div>
</div>
<div class="connection-status loading" *ngIf="loading">
	<mat-icon>sync</mat-icon>
	<span>{{ 'HINTS.please_wait' | translate | capitalize }}...</span>
</div>
